// Auto-generated skeleton bone data for demo
// This simulates what the CLI would generate

export const userCardBlueprints = {
  breakpoints: {
    375: {
      blueprints: [
        { x: 6, y: 24, w: 20, h: 56, r: 28 },       // Avatar circle
        { x: 32, y: 24, w: 50, h: 22, r: 0 },        // Name
        { x: 32, y: 50, w: 35, h: 16, r: 0 },        // Role
        { x: 6, y: 92, w: 40, h: 14, r: 0 },         // Location
        { x: 6, y: 114, w: 45, h: 14, r: 0 },        // Email
        { x: 6, y: 146, w: 88, h: 40, r: 4 },        // Button
      ],
    },
    768: {
      blueprints: [
        { x: 6, y: 24, w: 18, h: 56, r: 28 },
        { x: 28, y: 24, w: 52, h: 22, r: 0 },
        { x: 28, y: 50, w: 38, h: 16, r: 0 },
        { x: 6, y: 92, w: 42, h: 14, r: 0 },
        { x: 6, y: 114, w: 48, h: 14, r: 0 },
        { x: 6, y: 146, w: 88, h: 40, r: 4 },
      ],
    },
    1024: {
      blueprints: [
        { x: 7, y: 24, w: 22, h: 56, r: 28 },
        { x: 34, y: 24, w: 48, h: 22, r: 0 },
        { x: 34, y: 50, w: 32, h: 16, r: 0 },
        { x: 7, y: 92, w: 35, h: 14, r: 0 },
        { x: 7, y: 114, w: 40, h: 14, r: 0 },
        { x: 7, y: 146, w: 86, h: 40, r: 4 },
      ],
    },
    1440: {
      blueprints: [
        { x: 7, y: 24, w: 18, h: 56, r: 28 },
        { x: 28, y: 24, w: 42, h: 22, r: 0 },
        { x: 28, y: 50, w: 28, h: 16, r: 0 },
        { x: 7, y: 92, w: 30, h: 14, r: 0 },
        { x: 7, y: 114, w: 35, h: 14, r: 0 },
        { x: 7, y: 146, w: 86, h: 40, r: 4 },
      ],
    },
  },
};

export const productCardBlueprints = {
  breakpoints: {
    375: {
      blueprints: [
        { x: 0, y: 0, w: 100, h: 192, r: 0 },       // Image
        { x: 5, y: 204, w: 30, h: 16, r: 0 },        // Rating
        { x: 5, y: 228, w: 85, h: 22, r: 0 },        // Title
        { x: 5, y: 258, w: 70, h: 14, r: 0 },        // Description
        { x: 5, y: 290, w: 25, h: 28, r: 0 },        // Price
        { x: 65, y: 286, w: 30, h: 36, r: 4 },       // Button
      ],
    },
    768: {
      blueprints: [
        { x: 0, y: 0, w: 100, h: 192, r: 0 },
        { x: 5, y: 204, w: 32, h: 16, r: 0 },
        { x: 5, y: 228, w: 88, h: 22, r: 0 },
        { x: 5, y: 258, w: 75, h: 14, r: 0 },
        { x: 5, y: 290, w: 28, h: 28, r: 0 },
        { x: 62, y: 286, w: 33, h: 36, r: 4 },
      ],
    },
    1024: {
      blueprints: [
        { x: 0, y: 0, w: 100, h: 192, r: 0 },
        { x: 5, y: 204, w: 28, h: 16, r: 0 },
        { x: 5, y: 228, w: 82, h: 22, r: 0 },
        { x: 5, y: 258, w: 68, h: 14, r: 0 },
        { x: 5, y: 290, w: 22, h: 28, r: 0 },
        { x: 65, y: 286, w: 30, h: 36, r: 4 },
      ],
    },
    1440: {
      blueprints: [
        { x: 0, y: 0, w: 100, h: 192, r: 0 },
        { x: 5, y: 204, w: 25, h: 16, r: 0 },
        { x: 5, y: 228, w: 78, h: 22, r: 0 },
        { x: 5, y: 258, w: 60, h: 14, r: 0 },
        { x: 5, y: 290, w: 20, h: 28, r: 0 },
        { x: 68, y: 286, w: 27, h: 36, r: 4 },
      ],
    },
  },
};

export const dashboardStatBlueprints = {
  breakpoints: {
    375: {
      blueprints: [
        { x: 6, y: 24, w: 20, h: 48, r: 8 },        // Icon
        { x: 70, y: 24, w: 24, h: 18, r: 0 },        // Change %
        { x: 6, y: 88, w: 40, h: 14, r: 0 },         // Label
        { x: 6, y: 110, w: 55, h: 32, r: 0 },        // Value
      ],
    },
    768: {
      blueprints: [
        { x: 8, y: 24, w: 22, h: 48, r: 8 },
        { x: 68, y: 24, w: 22, h: 18, r: 0 },
        { x: 8, y: 88, w: 38, h: 14, r: 0 },
        { x: 8, y: 110, w: 50, h: 32, r: 0 },
      ],
    },
    1024: {
      blueprints: [
        { x: 8, y: 24, w: 24, h: 48, r: 8 },
        { x: 66, y: 24, w: 24, h: 18, r: 0 },
        { x: 8, y: 88, w: 42, h: 14, r: 0 },
        { x: 8, y: 110, w: 55, h: 32, r: 0 },
      ],
    },
    1440: {
      blueprints: [
        { x: 8, y: 24, w: 18, h: 48, r: 8 },
        { x: 72, y: 24, w: 20, h: 18, r: 0 },
        { x: 8, y: 88, w: 35, h: 14, r: 0 },
        { x: 8, y: 110, w: 48, h: 32, r: 0 },
      ],
    },
  },
};

export const articlePreviewBlueprints = {
  breakpoints: {
    375: {
      blueprints: [
        { x: 0, y: 0, w: 100, h: 240, r: 0 },       // Hero image
        { x: 4, y: 256, w: 18, h: 24, r: 12 },       // Category tag
        { x: 26, y: 258, w: 16, h: 18, r: 0 },       // Read time
        { x: 4, y: 296, w: 92, h: 32, r: 0 },        // Title
        { x: 4, y: 340, w: 88, h: 18, r: 0 },        // Description line 1
        { x: 4, y: 364, w: 75, h: 18, r: 0 },        // Description line 2
        { x: 4, y: 400, w: 10, h: 40, r: 20 },       // Author avatar
        { x: 16, y: 404, w: 25, h: 16, r: 0 },       // Author name
        { x: 16, y: 424, w: 30, h: 12, r: 0 },       // Author role
        { x: 4, y: 460, w: 30, h: 40, r: 4 },        // CTA button
      ],
    },
    768: {
      blueprints: [
        { x: 0, y: 0, w: 100, h: 280, r: 0 },
        { x: 4, y: 296, w: 14, h: 24, r: 12 },
        { x: 20, y: 298, w: 12, h: 18, r: 0 },
        { x: 4, y: 336, w: 88, h: 36, r: 0 },
        { x: 4, y: 384, w: 82, h: 18, r: 0 },
        { x: 4, y: 408, w: 70, h: 18, r: 0 },
        { x: 4, y: 444, w: 6, h: 40, r: 20 },
        { x: 12, y: 448, w: 20, h: 16, r: 0 },
        { x: 12, y: 468, w: 25, h: 12, r: 0 },
        { x: 4, y: 504, w: 22, h: 40, r: 4 },
      ],
    },
    1024: {
      blueprints: [
        { x: 0, y: 0, w: 100, h: 320, r: 0 },
        { x: 3, y: 336, w: 10, h: 24, r: 12 },
        { x: 15, y: 338, w: 8, h: 18, r: 0 },
        { x: 3, y: 376, w: 82, h: 40, r: 0 },
        { x: 3, y: 428, w: 78, h: 18, r: 0 },
        { x: 3, y: 452, w: 65, h: 18, r: 0 },
        { x: 3, y: 488, w: 5, h: 40, r: 20 },
        { x: 10, y: 492, w: 16, h: 16, r: 0 },
        { x: 10, y: 512, w: 20, h: 12, r: 0 },
        { x: 3, y: 548, w: 18, h: 40, r: 4 },
      ],
    },
    1440: {
      blueprints: [
        { x: 0, y: 0, w: 100, h: 320, r: 0 },
        { x: 3, y: 336, w: 8, h: 24, r: 12 },
        { x: 12, y: 338, w: 6, h: 18, r: 0 },
        { x: 3, y: 376, w: 78, h: 40, r: 0 },
        { x: 3, y: 428, w: 72, h: 18, r: 0 },
        { x: 3, y: 452, w: 58, h: 18, r: 0 },
        { x: 3, y: 488, w: 4, h: 40, r: 20 },
        { x: 8, y: 492, w: 12, h: 16, r: 0 },
        { x: 8, y: 512, w: 15, h: 12, r: 0 },
        { x: 3, y: 548, w: 14, h: 40, r: 4 },
      ],
    },
  },
};

